import WebSupportChat from './WebSupportChat';

const SUPPORT_OPTIONS = [
  {
    key: 'ai',
    title: 'Ask AI Support',
    subtitle: 'Get an instant product answer',
  },
  {
    key: 'report',
    title: 'Report an Issue',
    subtitle: "Something isn't working",
  },
  {
    key: 'question',
    title: 'Ask a Question',
    subtitle: 'Get help or clarification',
  },
  {
    key: 'feature',
    title: 'Request a Feature',
    subtitle: 'Suggest an improvement',
  },
];

const SUPPORT_FORMS = {
  report: {
    title: 'Report an Issue',
    subtitle: "Tell us what's not working",
    placeholder: 'Briefly describe your issue...',
  },
  question: {
    title: 'Ask a Question',
    subtitle: "We're here to help",
    placeholder: 'What do you need help with?',
  },
  feature: {
    title: 'Request a Feature',
    subtitle: 'Share your idea with us',
    placeholder: 'Describe your idea...\nWhat would this help you do?',
  },
};

const SUPPORT_SUCCESS = {
  report: {
    title: 'Issue reported',
    message: 'Our team is reviewing this now.\nWe’ll get back to you shortly via email.',
  },
  question: {
    title: 'Question received',
    message: 'Our team will review your message and get back to you shortly via email.',
  },
  feature: {
    title: 'Feature requested',
    message: 'Thanks for the suggestion.\nOur team will review it and follow up via email.',
  },
};

export default function SchoolSupportModal({
  view,
  successType,
  drafts,
  sending,
  error,
  successButtonLabel = 'Return to Dashboard',
  onClose,
  onBack,
  onSelectView,
  onDraftChange,
  onSend,
  onReturnToDashboard,
  token,
  schoolId,
  aiEnabled = false,
}) {
  if (!view) return null;

  const isMenu = view === 'menu';
  const isSuccess = view === 'success';
  const isAi = view === 'ai';
  const activeForm = !isMenu && !isSuccess && !isAi ? SUPPORT_FORMS[view] : null;
  const successCopy = isSuccess ? SUPPORT_SUCCESS[successType] || SUPPORT_SUCCESS.report : null;
  const currentDraft = activeForm ? drafts?.[view] || '' : '';

  return (
    <div className="sd-support-overlay" onClick={onClose}>
      <div
        className={`sd-support-modal ${isMenu ? 'sd-support-modal-menu' : ''} ${!isMenu ? 'sd-support-modal-form' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        {isMenu ? (
          <>
            <div className="sd-support-menu-header">
              <div className="sd-support-menu-copy">
                <div className="sd-support-eyebrow">Support</div>
                <div className="sd-support-mini-copy">Get help with car-pool</div>
              </div>

              <div className="sd-support-menu-intro">
                <h2>How can we help?</h2>
                <p>We&apos;re committed to providing fast, reliable support to keep your dismissal running smoothly</p>
              </div>
            </div>

            <div className="sd-support-option-list">
              {SUPPORT_OPTIONS.filter((option) => option.key !== 'ai' || (aiEnabled && token && schoolId)).map((option) => (
                <button
                  key={option.key}
                  type="button"
                  className="sd-support-option"
                  onClick={() => onSelectView(option.key)}
                >
                  <div className="sd-support-option-copy">
                    <div className="sd-support-option-title">{option.title}</div>
                    <div className="sd-support-option-subtitle">{option.subtitle}</div>
                  </div>
                  <span className="sd-support-option-arrow" aria-hidden="true">→</span>
                </button>
              ))}
            </div>
          </>
        ) : null}

        {activeForm ? (
          <>
            <div className="sd-support-form-header">
              <button type="button" className="sd-support-back" onClick={onBack} aria-label="Back">
                ←
              </button>

              <div className="sd-support-form-copy">
                <h2>{activeForm.title}</h2>
                <p>{activeForm.subtitle}</p>
              </div>
            </div>

            <div className="sd-support-form-card">
              <textarea
                className="sd-support-textarea"
                value={currentDraft}
                onChange={(event) => onDraftChange(view, event.target.value)}
                placeholder={activeForm.placeholder}
                disabled={sending}
              />

              {error ? <div className="sd-support-error">{error}</div> : null}

              <button
                type="button"
                className="sd-support-send"
                onClick={() => onSend(view)}
                disabled={!currentDraft.trim() || sending}
              >
                {sending ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </>
        ) : null}

        {isAi ? (
          <>
            <div className="sd-support-form-header">
              <button type="button" className="sd-support-back" onClick={onBack} aria-label="Back">←</button>
              <div className="sd-support-form-copy">
                <h2>Car-Pool AI Support</h2>
                <p>Instant help with the school dashboard</p>
              </div>
            </div>
            <WebSupportChat token={token} schoolId={schoolId} />
          </>
        ) : null}

        {isSuccess ? (
          <div className="sd-support-success">
            <div className="sd-support-success-copy">
              <h2>{successCopy.title}</h2>
              <p>{successCopy.message}</p>
            </div>

            <div className="sd-support-success-icon" aria-hidden="true">
              <span>✓</span>
            </div>

            <button type="button" className="sd-support-send" onClick={onReturnToDashboard}>
              {successButtonLabel}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
